// Auto-split from i18n.js — language: pol
export default {
    translation: {
        // routes & menus
        Dashboard: 'Panel główny',
        'Space Data': 'Dane przestrzeni',
        'Equipment Data': 'Dane urządzeń',
        'Meter Data': 'Dane liczników',
        'Tenant Data': 'Dane najemców',
        'Store Data': 'Dane sklepów',
        'Shopfloor Data': 'Dane hal produkcyjnych',
        'Combined Equipment Data': 'Dane urządzeń zespolonych',
        'Auxiliary System': 'Systemy pomocnicze',
        Microgrid: 'Mikrosieć',
        'Energy Storage Power Station': 'Elektrownia',
        'Photovoltaic Power Station': 'Elektrownia',
        'Fault Alarm': 'Alarm awaryjny',
        Monitoring: 'Monitorowanie urządzeń',
        'Advanced Reporting': 'Zaawansowane raportowanie',
        'Knowledge Base': 'Baza wiedzy',
        'Energy Category Data': 'Analiza kategorii energii',
        'Energy Item Data': 'Analiza pozycji zużycia energii',
        Carbon: 'Analiza emisji CO2',
        Cost: 'Analiza kosztów',
        Output: 'Analiza wytwarzania',
        Income: 'Analiza dochodów',
        Efficiency: 'Analiza efektywności',
        Load: 'Analiza obciążenia',
        Statistics: 'Analiza statystyczna',
        'Batch Analysis': 'Analiza zbiorcza',
        Saving: 'Analiza oszczędności energiiⒺ',
        Plan: 'Analiza planistycznaⒺ',
        Prediction: 'Analiza predykcyjnaⒺ',
        'Production': 'Wielkość produkcji',
        'Space Production': 'Analiza produkcji i zużycia energii w przestrzeniach',
        'Equipment Tracking': 'Rejestr urządzeń',
        'Equipment Comparison': 'Analiza porównawcza urządzeń',
        'Shopfloor Comparison': 'Analiza porównawcza hal produkcyjnych',
        'Store Comparison': 'Analiza porównawcza sklepów',
        'Space Comparison': 'Analiza porównawcza przestrzeni',
        'Combined Equipment Comparison': 'Analiza porównawcza urządzeń zespolonych',
        'Tenant Comparison': 'Analiza porównawcza najemców',
        'Environment Monitor': 'Monitorowanie środowiska',
        'Meter Energy': 'Analiza zużycia energii przez liczniki',
        'Meter Prediction': 'Prognoza licznikaⒺ',
        'Virtual Meter Prediction': 'Prognoza wirtualnego licznikaⒺ',
        'Offline Meter Prediction': 'Prognoza licznika offlineⒺ',
        'Meter Carbon': 'Analiza emisji CO2 przez liczniki',
        'Meter Cost': 'Analiza kosztów liczników',
        'Meter Trend': 'Analiza trendów liczników',
        'Meter Realtime': 'Analiza czasu rzeczywistego liczników',
        'Meter Saving': 'Analiza oszczędności energii przez licznikiⒺ',
        'Meter Plan': 'Analiza planistyczna licznikówⒺ',
        'Master Meter Submeters Balance': 'Analiza bilansu licznika głównego i podliczników',
        'Meter Batch Analysis': 'Analiza zbiorcza liczników',
        'Meter Comparison': 'Analiza porównawcza liczników',
        'Meter Tracking': 'Rejestr liczników',
        'Virtual Meter Saving': 'Analiza oszczędności energii przez liczniki wirtualneⒺ',
        'Virtual Meter Plan': 'Analiza planistyczna liczników wirtualnychⒺ',
        'Virtual Meter Energy': 'Analiza zużycia energii przez liczniki wirtualne',
        'Virtual Meter Carbon': 'Analiza emisji CO2 przez liczniki wirtualne',
        'Virtual Meter Cost': 'Analiza kosztów liczników wirtualnych',
        'Virtual Meter Batch Analysis': 'Analiza zbiorcza liczników wirtualnych',
        'Virtual Meter Comparison': 'Analiza porównawcza liczników wirtualnych',
        'Offline Meter Energy': 'Analiza zużycia energii przez liczniki offline',
        'Offline Meter Carbon': 'Analiza emisji CO2 przez liczniki offline',
        'Offline Meter Cost': 'Analiza kosztów liczników offline',
        'Offline Meter Batch Analysis': 'Analiza zbiorcza liczników offline',
        'Offline Meter Saving': 'Analiza oszczędności energii przez liczniki offlineⒺ',
        'Offline Meter Plan': 'Analiza planistyczna liczników offlineⒺ',
        'Offline Meter Input': 'Wprowadzanie danych liczników offline',
        'Tenant Bill': 'Rachunek najemcy',
        'Energy Flow Diagram': 'Schemat przepływu energii',
        'Distribution System': 'System rozdziału energii',
        'SVG System': 'System wizualizacji konfiguracji',
        'Faults Data': 'Analiza usterek',
        'Space Equipments': 'Urządzenia w przestrzeni',
        'Combined Equipments': 'Urządzenia zespolone',
        'Energy Storage Power Station List': 'Lista elektrowni',
        'Energy Storage Power Station Details': 'Monitorowanie urządzeń',
        'Energy Storage Power Station Reporting': 'Raporty danych',
        'Energy Storage Power Station Alarm': 'Alarm awaryjny',
        'Energy Storage Power Station Maintenance': 'Konserwacja i utrzymanie',
        'Enter Production': 'Wprowadzanie wielkości produkcji',
        'Multiple Microgrids': 'Dane wielu elektrowni',
        'Multiple Microgrids Dashboard': 'Panel główny wielu elektrowni',
        'Multiple Microgrids List': 'Lista elektrowni',
        'Single Microgrid': 'Dane pojedynczej elektrowni',
        'Single Microgrid Dashboard': 'Panel główny pojedynczej elektrowni',
        'Single Microgrid Details': 'Dane urządzeń',
        'Single Microgrid Fault Alarm': 'Alarm awaryjny',
        'Microgrid Reports': 'Raporty statystyczne',
        'Microgrid Reports Energy': 'Raport energii',
        'Microgrid Reports Revenue': 'Raport przychodów',
        'Microgrid Reports Parameters': 'Zapytanie danych',
        'Multiple Energy Storage Power Stations': 'Dane wielu elektrowni magazynujących energię',
        'Multiple Energy Storage Power Stations Dashboard': 'Panel główny wielu elektrowni magazynujących energię',
        'Multiple Energy Storage Power Stations List': 'Lista elektrowni magazynujących energię',
        'Single Energy Storage Power Station': 'Dane pojedynczej elektrowni magazynującej energię',
        'Single Energy Storage Power Station Dashboard': 'Panel główny pojedynczej elektrowni magazynującej energię',
        'Single Energy Storage Power Station Details': 'Dane urządzeń magazynujących energię',
        'Single Energy Storage Power Station Fault Alarm': 'Alarm awaryjny elektrowni magazynującej energię',
        'Energy Storage Power Station Reports': 'Raporty statystyczne elektrowni magazynującej energię',
        'Energy Storage Power Station Reports Energy': 'Raport energii elektrowni magazynującej energię',
        'Energy Storage Power Station Reports Revenue': 'Raport przychodów elektrowni magazynującej energię',
        'Energy Storage Power Station Reports Parameters': 'Zapytanie danych elektrowni magazynującej energię',
        'Photovoltaic Power Station List': 'Lista elektrowni fotowoltaicznych',
        'Photovoltaic Power Station Details': 'Monitorowanie urządzeń',
        'Photovoltaic Power Station Reporting': 'Raporty danych',
        'Photovoltaic Power Station Alarm': 'Alarm awaryjny',
        'Photovoltaic Power Station Maintenance': 'Konserwacja i utrzymanie',
        'Multiple Photovoltaic Power Stations': 'Dane wielu elektrowni fotowoltaicznych',
        'Multiple Photovoltaic Power Stations Dashboard': 'Panel główny wielu elektrowni fotowoltaicznych',
        'Multiple Photovoltaic Power Stations List': 'Lista elektrowni fotowoltaicznych',
        'Single Photovoltaic Power Station': 'Dane pojedynczej elektrowni fotowoltaicznej',
        'Single Photovoltaic Power Station Dashboard': 'Panel główny pojedynczej elektrowni fotowoltaicznej',
        'Single Photovoltaic Power Station Details': 'Dane urządzeń',
        'Single Photovoltaic Power Station Fault Alarm': 'Alarm awaryjny elektrowni fotowoltaicznej',
        'Photovoltaic Power Station Reports': 'Raporty statystyczne elektrowni fotowoltaicznej',
        'Photovoltaic Power Station Reports Energy': 'Raport energii elektrowni fotowoltaicznej',
        'Photovoltaic Power Station Reports Revenue': 'Raport przychodów elektrowni fotowoltaicznej',
        'Photovoltaic Power Station Reports Parameters': 'Zapytanie danych elektrowni fotowoltaicznej',
        'Work Order': 'Zarządzanie zleceniami pracy',
        'Work Order Installation': 'Rejestr instalacji',
        'Work Order Repair': 'Rejestr napraw',
        'Work Order Inspection': 'Rejestr inspekcji',
        'Total Number of Work Orders': 'Całkowita liczba zleceń pracy',
        'Number of New Work Orders': 'Liczba nowych zleceń pracy',
        'Number of Inprogress Work Orders': 'Liczba zleceń pracy w toku',
        'Number of Done Work Orders': 'Liczba wykonanych zleceń pracy',
        'Fuel Indicator': 'Zużycie paliwa',
        'Charge Energy Indicator': 'Energia ładowania',
        'Discharge Energy Indicator': 'Energia rozładowania',
        'Charge Cost Indicator': 'Koszt ładowania',
        'Discharge Revenue Indicator': 'Przychód z rozładowania',
        'HVAC': 'Klimatyzacja',
        'Fire Control': 'Ochrona przeciwpożarowa',
        'Store Dashboard': 'Panel Sklepów',
        'Comprehensive overview of store energy performance': 'Kompleksowy przegląd wydajności energetycznej sklepów',
        'Total Stores': 'Łączna Liczba Sklepów',
        'Total Area': 'Całkowita Powierzchnia',
        'Active Meters': 'Aktywne Liczniki',
        'Active Alerts': 'Aktywne Alerty',
        'Total Energy Consumption': 'Całkowite Zużycie Energii',
        'Carbon Emissions': 'Emisja Dwutlenku Węgla',
        'Current Period': 'Bieżący Okres',
        'Energy Consumption by Category': 'Zużycie Energii według Kategorii',
        'Cost Distribution by Category': 'Rozkład Kosztów według Kategorii',
        'Monthly Energy & Cost Trends': 'Miesięczne Trendy Energii i Kosztów',
        'Top 5 Energy Consuming Stores': 'Top 5 Sklepów o Największym Zużyciu Energii',
        'Energy Category Details': 'Szczegóły Kategorii Energii',
        'Store Performance Overview': 'Przegląd Wydajności Sklepów',
        'YoY Change': 'Zmiana Rok do Roku',
        'Per m²': 'Na m²',
        'Usage Intensity': 'Intensywność Użytkowania',
        'Dashboard data loaded successfully': 'Dane panelu załadowane pomyślnie',
        'Failed to load dashboard data': 'Nie udało się załadować danych panelu',
        'Store Name': 'Nazwa Sklepu',
        'Store Area': 'Powierzchnia Sklepu',
        'Energy Consumption': 'Zużycie Energii',
        'Consumption': 'Zużycie',
        'last period': 'ostatni okres',
        // Tenant Dashboard
        'Tenant Dashboard': 'Panel Najemców',
        'Comprehensive overview of tenant energy performance': 'Kompleksowy przegląd wydajności energetycznej najemców',
        'Total Tenants': 'Łączna Liczba Najemców',
        'Tenant Performance Overview': 'Przegląd Wydajności Najemców',
        'Tenant Name': 'Nazwa Najemcy',
        'Tenant Area': 'Powierzchnia Najemcy',
        'Tenant Type': 'Typ Najemcy',
        // Equipment Dashboard
        'Equipment Dashboard': 'Panel Urządzeń',
        'Total Equipments': 'Liczba Urządzeń',
        'Equipment Performance Overview': 'Przegląd Wydajności Urządzeń',
        'Equipment Name': 'Nazwa Urządzenia',
        'Equipment Type': 'Typ Urządzenia',
        'Total Energy': 'Energia Ogółem',
        'Total Sensors': 'Liczba Czujników',
        'Increment Rate': 'Współczynnik Wzrostu',
        // Shopfloor Dashboard
        'Total Shopfloors': 'Łączna liczba warsztatów',
        'Shopfloor Performance Overview': 'Przegląd wydajności warsztatów',
        'Shopfloor Name': 'Nazwa warsztatu',
        'Shopfloor Area': 'Powierzchnia warsztatu',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'Łączna liczba urządzeń zespolonych',
        'Combined Equipment Performance Overview': 'Przegląd wydajności urządzeń zespolonych',
        'Combined Equipment Name': 'Nazwa urządzenia zespolonego',
        'Associated Equipments': 'Powiązane urządzenia',

        // Dashboard
        'Welcome to QiXuan': 'Witamy w QiXuan',
        'An Industry Leading Energy Management System': 'Wiodący w branży system zarządzania energią',
        "This Year's Consumption CATEGORY VALUE UNIT": 'Zużycie w tym roku {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": 'Koszty w tym roku {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": 'Zużycie w tym miesiącu {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": 'Wytworzenie w tym miesiącu {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Costs CATEGORY VALUE UNIT": 'Koszty w tym miesiącu {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': 'Zużycie w tym samym okresie rok temu {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year': 'Koszty w tym samym okresie rok temu {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'CATEGORY Consumption UNIT': 'Zużycie {{CATEGORY}} {{UNIT}}',
        'CATEGORY Costs UNIT': 'Koszty {{CATEGORY}} {{UNIT}}',
        // Entities
        Space: 'Przestrzeń',
        Equipment: 'Urządzenie',
        Meter: 'Licznik',
        'Offline Meter': 'Licznik offline',
        'Virtual Meter': 'Licznik wirtualny',
        Tenant: 'Najemca',
        Store: 'Sklep',
        Shopfloor: 'Hala produkcyjna',
        'Combined Equipment': 'Urządzenie zespolone',
        'Cost Center': 'Centrum kosztów',
        Name: 'Nazwa',
        DisplayName: 'Nazwa wyświetlana',
        UserName: 'Nazwa użytkownika',
        Description: 'Opis',
        'Energy Category': 'Kategoria energii',
        'Child Spaces': 'Przestrzenie podrzędne',
        'Associated Equipment': 'Powiązane urządzenia',
        //Energy Categories
        Electricity: 'Energia elektryczna',
        Water: 'Woda',
        'Natural Gas': 'Gaz ziemny',
        // SidePanelModal
        Settings: 'Ustawienia',
        'Set your own customized style': 'Ustaw swój własny styl',
        'Color Scheme': 'Schemat kolorów',
        'Choose the perfect color mode for your app': 'Wybierz idealny tryb kolorów dla swojej aplikacji',
        Light: 'Jasny',
        Dark: 'Ciemny',
        'RTL Mode': 'Tryb RTL',
        'Switch your language direction': 'Zmień kierunek języka',
        'Fluid Layout': 'Układ płynny',
        'Toggle container layout system': 'Przełącz system układu kontenera',
        'Navigation Position': 'Pozycja nawigacji',
        'Vertical': 'Pionowa',
        'Top': 'Górna',
        'Combo': 'Kombinacja',
        'Transparent': 'Przezroczysta',
        'Inverted': 'Odwrócona',
        'Card': 'Karta',
        'Vibrant': 'Żywa',
        'Select a suitable navigation system for your web application': 'Wybierz odpowiedni system nawigacji dla swojej aplikacji webowej',
        'Vertical Nav': 'Nawigacja pionowa',
        'Top Nav': 'Nawigacja górna',
        'Vertical Navbar Style': 'Styl pionowego paska nawigacyjnego',
        'Switch between styles for your vertical navbar': 'Przełączaj między stylami pionowego paska nawigacyjnego',
        Language: 'Język',
        'Switch between languages': 'Przełącz języki',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': 'Podoba Ci się to, co widzisz?',
        'Get QiXuan now': 'Pobierz QiXuan teraz',
        'PQ.About': 'Analiza obejmuje odchylenie napięcia, niezrównoważenie napięcia, odchylenie częstotliwości i niezrównoważenie prądu. Odchylenie napięcia obliczane jako (U−Un)/Un×100%; odchylenie częstotliwości jako |f−fn|; niezrównoważenie trójfazowe jako max(|Xi−Xavg|)/Xavg×100%, z wymaganiem wyrównania czasowego kanałów trójfazowych. Wyniki bazują na szeregach czasowych wybranego licznika w okresie raportowania. Brak kanałów trójfazowych lub niewyrównane znaczniki czasowe spowodują pominięcie wskaźników niezrównoważenia. Chwilowe skoki lub brak próbek mogą zwiększać wartości maksymalne; dla oceny stanu ustalonego zaleca się odwołanie do współczynnika zgodności oraz wskaźników statystycznych takich jak P95.',
        Purchase: 'Zakup wersji Enterprise',
        ContactInfo: 'Informacje Kontaktowe',
        ProductWebsite: 'Strona Produktu',
        CompanyWebsite: 'Strona Firmy',
        SalesPhone: 'Telefon Sprzedazy',
        // Query Panels
        'Base Period Begins': 'Okres bazowy rozpoczyna się',
        'Base Period Ends': 'Okres bazowy kończy się',
        'Comparison Types': 'Typy porównań',
        'Year-Over-Year': 'Rok do roku',
        'Month-On-Month': 'Miesiąc do miesiąca',
        'Free Comparison': 'Porównanie dowolne',
        'None Comparison': 'Brak porównania',
        'Reporting Period Begins': 'Okres raportowania rozpoczyna się',
        'Reporting Period Ends': 'Okres raportowania kończy się',
        '(Optional)': '(Opcjonalne)',
        'Period Types': 'Skale czasowe',
        Yearly: 'Rocznie',
        Monthly: 'Miesięcznie',
        Weekly: 'Tygodniowo',
        Daily: 'Dziennie',
        Hourly: 'Godzinowo',
        Submit: 'Zatwierdź',
        'Input Energy Category': 'Kategoria zużywanej energii',
        'Output Energy Category': 'Kategoria wytwarzanej energii',
        'Fraction Parameter': 'Parametr ułamka',
        Search: 'Szukaj',
        //DateRangePicker
        sunday: 'Niedz',
        monday: 'Pon',
        tuesday: 'Wt',
        wednesday: 'Śr',
        thursday: 'Czw',
        friday: 'Pt',
        saturday: 'Sob',
        ok: 'OK',
        today: 'Dziś',
        yesterday: 'Wczoraj',
        hours: 'Godziny',
        minutes: 'Minuty',
        seconds: 'Sekundy',
        last7Days: 'Ostatnie 7 dni',
        tomorrow: 'Jutro',
        dayAfterTomorrow: 'Pojutrze',
        next7Days: 'Następne 7 dni',
        'Select Date Range': 'Wybierz zakres dat',
        //Card Summaries and Line Charts
        'Base Period': 'Okres bazowy',
        'Reporting Period': 'Okres raportowania',
        'Per Unit Area': 'Na jednostkę powierzchni',
        'Per Capita': 'Na mieszkańca',
        'Per Unit Production': 'Na jednostkę produktu',
        Baseline: 'Wartość bazowa',
        Actual: 'Wartość rzeczywista',
        'Baseline Value - Actual Value': 'Wartość bazowa - wartość rzeczywista',
        'Average Load': 'Średnie obciążenie',
        'Maximum Load': 'Maksymalne obciążenie',
        'Load Factor': 'Współczynnik obciążenia',
        'Ratio of Average Load to Maximum Load': 'Stosunek średniego obciążenia do maksymalnego',
        'Carbon Dioxide Emissions by Energy Category': 'Udział emisji CO2 według kategorii energii',
        'Costs by Energy Category': 'Udział kosztów według kategorii energii',
        'Incomes by Energy Category': 'Udział dochodów według kategorii energii',
        'Electricity Consumption by Time-Of-Use': 'Zużycie energii elektrycznej według czasu użytkowania',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Emisje CO2 z energii elektrycznej według czasu użytkowania',
        'Electricity Cost by Time-Of-Use': 'Koszt energii elektrycznej według czasu użytkowania',
        'CATEGORY UNIT Consumption by Energy Items': 'Udział zużycia {{CATEGORY}} {{UNIT}} według pozycji energii',
        'Ton of Standard Coal by Energy Category': 'Udział ton ekwiwalentu węgla (TCE) według kategorii energii',
        'Ton of Carbon Dioxide Emissions by Energy Category': 'Udział ton emisji CO2 (TCO2E) według kategorii energii',
        'Reporting Period Consumption CATEGORY UNIT': 'Zużycie w okresie raportowania {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'Prognoza w okresie raportowania {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} zużycie w okresie raportowania {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} zużycie w okresie raportowania {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': 'Produkcja w okresie raportowania {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': 'Produkcja w okresie bazowym {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': 'Zużycie w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'Prognoza w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': 'Zużycie w okresie bazowym {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'Prognoza w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT': 'Zużycie w okresie raportowania {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': 'Zużycie w okresie raportowania {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT': 'Zużycie w okresie bazowym {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT': 'Udział przestrzeni podrzędnych {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': 'Łączny udział przestrzeni podrzędnych',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': 'Emisje CO2 w okresie raportowania {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Emisje CO2 w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': 'Emisje CO2 w okresie bazowym {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': 'Koszty w okresie raportowania {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': 'Koszty w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': 'Koszty w okresie bazowym {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': 'Wytworzenie w okresie raportowania {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} wytworzenie w okresie raportowania {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} wytworzenie w okresie raportowania {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': 'Wytworzenie w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': 'Wytworzenie w okresie bazowym {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': 'Dochód w okresie raportowania {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': 'Dochód w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': 'Dochód w okresie bazowym {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': 'Całkowity dochód w okresie raportowania {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT': 'Skumulowana efektywność w okresie raportowania {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} skumulowana efektywność w okresie raportowania {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} skumulowana efektywność kompleksowa w okresie raportowania {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} skumulowana efektywność kompleksowa w okresie raportowania {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} skumulowana efektywność kompleksowa w okresie bazowym {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': 'Efektywność chwilowa {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} efektywność chwilowa {{UNIT}}',
        'Equipment Efficiency Indicator': 'Wskaźnik efektywności energetycznej urządzenia',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} efektywność kompleksowa chwilowa {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT': 'Skumulowana efektywność w okresie raportowania {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT': 'Skumulowana efektywność w okresie raportowania {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': 'Skumulowana efektywność w okresie bazowym {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT': 'Skumulowana efektywność w okresie bazowym {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': 'Maksymalne obciążenie {{CATEGORY}} w okresie bazowym {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': 'Maksymalne obciążenie {{CATEGORY}} w okresie raportowania {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': 'Średnie obciążenie {{CATEGORY}} w okresie raportowania {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': 'Współczynnik obciążenia {{CATEGORY}} w okresie raportowania',
        'Base Period CATEGORY Average Load VALUE UNIT': 'Średnie obciążenie {{CATEGORY}} w okresie bazowym {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': 'Średnia {{CATEGORY}} w okresie raportowania {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': 'Maksimum {{CATEGORY}} w okresie raportowania {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': 'Minimum {{CATEGORY}} w okresie raportowania {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': 'Średnia arytmetyczna {{CATEGORY}} w okresie raportowania {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': 'Mediana {{CATEGORY}} w okresie raportowania {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': 'Odchylenie standardowe próbki {{CATEGORY}} w okresie raportowania {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': 'Wariancja próbki {{CATEGORY}} w okresie raportowania {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': 'Oszczędność w okresie raportowania {{CATEGORY}} (bazowa - rzeczywista) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': 'Zmniejszenie w okresie raportowania {{CATEGORY}} (bazowa - rzeczywista) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': 'Oszczędność w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': 'Oszczędność w okresie bazowym {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT': 'Zużycie licznika głównego w okresie raportowania {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': 'Zużycie licznika głównego w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT': 'Zużycie podliczników w okresie raportowania {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': 'Zużycie podliczników w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': 'Różnica w okresie raportowania {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': 'Procentowa różnica w okresie raportowania',
        'Reporting Period Difference CATEGORY VALUE UNIT': 'Różnica w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Trend Values': 'Wartości trendu',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': 'Lista usterek',
        'Reporting Period Number of Fault VALUE': 'Liczba usterek w okresie raportowania: {{VALUE}}',
        'All Faults': 'Wszystkie usterki',
        'Space Faults': 'Usterki przestrzeni',
        'Number of All Faults': 'Liczba wszystkich usterek',
        'Number of Space Faults': 'Liczba usterek przestrzeni',
        'Total Number of Faults': 'Całkowita liczba usterek',
        'Number of New Faults': 'Liczba nowych usterek',
        'Number of Inprogress Faults': 'Liczba usterek w toku',
        'Number of Done Faults': 'Liczba wykonanych usterek',
        //Data Panels
        'Ton of Standard Coal': 'Tona ekwiwalentu węgla',
        'Ton of Carbon Dioxide Emissions': 'Tona emisji CO2',
        'Carbon Emissions Per Unit Of Energy Consumption': 'Emisja CO2 na jednostkę zużycia energii',
        'Operating Characteristic Curve': 'Krzywa charakterystyki pracy',
        Tariff: 'Taryfa',
        'Detailed Data': 'Szczegółowe dane',
        'Child Spaces Data': 'Dane przestrzeni podrzędnych',
        'Associated Equipment Data': 'Dane powiązanych urządzeń',
        'This Year': 'W tym roku',
        'The Same Period Last Year': 'W tym samym okresie rok temu',
        'This Month': 'W tym miesiącu',
        'This Day': 'W tym dniu',
        Total: 'Razem',
        'No data found': 'Brak danych',
        Export: 'Eksportuj',
        'AI Analysis': 'Analiza AI',
        Datetime: 'Data i czas',
        'Time-Of-Use Type': 'Typ czasu użytkowania',
        'Top-Peak': 'Szczyt',
        'On-Peak': 'Szczyt',
        'Mid-Peak': 'Średnie obciążenie',
        'Off-Peak': 'Dolina',
        'Deep': 'Głęboka dolina',
        Percentage: 'Procent',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': 'Trend punktu wartości energii z ostatniej godziny',
        Circuit: 'Obwód',
        Point: 'Punkt danych',
        'Realtime Value': 'Wartość w czasie rzeczywistym',
        //Meter Tracking
        'Meter List': 'Lista liczników',
        'Edit Meter': 'Edytuj',
        'Start Value': 'Wartość początkowa',
        'End Value': 'Wartość końcowa',
        'Difference Value': 'Różnica',
        'Start Integrity Rate': 'Wskaźnik kompletności danych początkowych (%)',
        'End Integrity Rate': 'Wskaźnik kompletności danych końcowych (%)',
        'Full Integrity Rate': 'Całkowity wskaźnik kompletności danych (%)',
        'Start Integrity Rate Description': 'Wskaźnik integralności danych początkowych: Odsetek liczników, które pomyślnie uzyskały odczyty zużycia energii w momencie rozpoczęcia spośród wszystkich liczników w okresie statystycznym',
        'End Integrity Rate Description': 'Wskaźnik integralności danych końcowych: Odsetek liczników, które pomyślnie uzyskały odczyty zużycia energii w momencie zakończenia spośród wszystkich liczników w okresie statystycznym',
        'Full Integrity Rate Description': 'Pełny wskaźnik integralności danych: Odsetek liczników, które pomyślnie uzyskały odczyty zużycia energii zarówno w momencie rozpoczęcia, jak i zakończenia spośród wszystkich liczników w okresie statystycznym',
        //Equipment Tracking
        'Equipment List': 'Lista urządzeń',
        'Edit Equipment': 'Edytuj',
        //Profile Dropdown
        Feedback: 'Opinia',
        'Account Settings': 'Ustawienia konta',
        Logout: 'Wyloguj',
        //Authentication
        'Log in': 'Zaloguj się',
        'Email address': 'Adres e-mail',
        'Phone Number': 'Numer telefonu',
        Password: 'Hasło',
        CaptchaCode: 'Kod weryfikacyjny',
        Refresh: 'Odśwież',
        'Remember me': 'Zapamiętaj mnie',
        'Logged in as ': 'Zalogowany jako ',
        'Forgot Password?': 'Zapomniałeś hasła?',
        'Forgot your password?': 'Zapomniałeś hasła?',
        "Enter your email and we'll send you a reset link": 'Wprowadź swój adres e-mail, a wyślemy Ci link resetujący',
        "Enter your email and we'll send you a registration link": 'Wprowadź swój adres e-mail, a wyślemy Ci link rejestracyjny',
        'Reset Password': 'Zresetuj hasło',
        'Thanks for using QiXuan!': 'Dziękujemy za korzystanie z QiXuan!',
        'You are now successfully signed out': 'Pomyślnie wylogowano',
        'Return to Login': 'Powrót do logowania',
        'Please check your email!': 'Sprawdź swój e-mail!',
        'An email has been sent to ': 'E-mail został wysłany do ',
        'Please click on the included link to reset your password': 'Kliknij na załączony link, aby zresetować hasło',
        'Please click on the included link to register your account': 'Kliknij na załączony link, aby zarejestrować konto',
        'An email with password reset link is sent to ': 'E-mail z linkiem resetującym hasło został wysłany do ',
        'Change Password': 'Zmień hasło',
        'Old Password': 'Stare hasło',
        'New Password': 'Nowe hasło',
        'Confirm Password': 'Potwierdź nowe hasło',
        'Update Password': 'Aktualizuj hasło',
        'Password has been changed!': 'Hasło zostało zmienione!',
        'Verification code has been sent to your inbox. \
        Please copy it to the input box below.':
            'Kod weryfikacyjny został wysłany na Twoją skrzynkę pocztową. Skopiuj go do poniższego pola.',
        'New to QiXuan': 'Nowy w QiXuan',
        'Create an account': 'Utwórz konto',
        'EMAIL Account registration successful': 'Rejestracja konta {{EMAIL}} zakończona sukcesem',
        'Thanks for verifying your account!': 'Dziękujemy za weryfikację konta!',
        'Your code is': 'Twój kod to',
        'Send verification code': 'Wyślij kod weryfikacyjny',
        'Please wait for NUMBER seconds': 'Poczekaj {{NUMBER}} sekund',
        'Password reset': 'Reset hasła',
        'Please wait for approval': 'Proszę czekać na zatwierdzenie',
        //notification
        Notifications: 'Powiadomienia',
        'Mark all as read': 'Oznacz wszystkie jako przeczytane',
        'View all': 'Zobacz wszystkie',
        'Notification New': 'Nowe',
        'Notification Earlier': 'Wcześniejsze',
        'Notification List': 'Lista powiadomień',
        'Bulk actions': 'Akcje zbiorcze',
        'Notification Subject': 'Temat',
        'Notification Created Datetime': 'Czas utworzenia',
        'Notification Message': 'Treść',
        'Notification Priority': 'Priorytet',
        'Notification Status': 'Status',
        'Notification Mark As Read': 'Oznacz jako przeczytane',
        'Notification Mark As Acknowledged': 'Potwierdź',
        'Notification Low': 'Niski',
        'Notification Medium': 'Średni',
        'Notification High': 'Wysoki',
        'Notification Critical': 'Krytyczny',
        'Notification Unread': 'Nieprzeczytane',
        'Notification Read': 'Przeczytane',
        'Notification Acknowledged': 'Potwierdzone',
        'Notification Archive': 'Archiwizuj',
        'Notification Delete': 'Usuń',
        'Notification Apply': 'Zastosuj',
        'Notification Start Datetime': 'Czas rozpoczęcia',
        'Notification End Datetime': 'Czas zakończenia',
        'Notification Update Datetime': 'Czas aktualizacji',
        //Monitoring
        'Run Commands': 'Uruchom polecenia',
        'Pin Code': 'Kod PIN',
        'Unlock': 'Odblokuj',
        'Set Value': 'Ustaw wartość',
        'Fault Alarms': 'Alarmy awaryjne',
        'Instantaneous Efficiency VALUE UNIT': 'Efektywność chwilowa {{VALUE}} {{UNIT}}',
        'Communication Status': 'Status komunikacji',
        'Communication Online': 'Online',
        'Communication Offline': 'Offline',
        'Equipment Status': 'Status urządzenia',
        'Equipment Running': 'Praca',
        'Equipment Stopped': 'Zatrzymane',
        'Show Up to': 'Pokaż do',
        All: 'Wszystko',
        'FROM - TO of TOTAL': 'Wyświetlane {{FROM}} - {{TO}} z {{TOTAL}}',
        //Microgrid
        'Microgrid Energy': 'Energia',
        'Microgrid Revenue': 'Przychód',
        'Microgrid Carbon': 'Emisje CO2',
        'Photovoltaic Generation': 'Generacja fotowoltaiczna',
        'EV Charger Consumption': 'Zużycie ładowarek EV',
        'Load Consumption': 'Zużycie obciążenia',
        'Grid Buy': 'Zakup z sieci',
        'Grid Sell': 'Sprzedaż do sieci',
        'EV Charger': 'Ładowarka EV',
        'Heat Pump': 'Pompa ciepła',
        'Photovoltaic': 'Fotowoltaika',
        'PCS Run State': 'Status pracy PCS',
        'PCS Unknown': 'Nieznany',
        'PCS Initializing': 'Inicjalizacja zasilania',
        'PCS Standby': 'Czuwanie',
        'PCS Shutdown': 'Wyłączony',
        'PCS Fault': 'Usterka',
        'PCS Running': 'Praca',
        'Battery Power': 'Moc baterii',
        'Photovoltaic Power': 'Moc fotowoltaiki',
        'Grid Power': 'Moc sieci',
        'Load Power': 'Moc obciążenia',
        Reporting: 'Raportowanie danych',
        Maintenance: 'Konserwacja',
        'General Information': 'Informacje ogólne',
        'Serial Number': 'Numer seryjny',
        Address: 'Adres',
        'Postal Code': 'Kod pocztowy',
        'Rated Capacity': 'Pojemność znamionowa',
        'Rated Power': 'Moc znamionowa',
        Latitude: 'Szerokość geograficzna',
        Longitude: 'Długość geograficzna',
        'Strategy Management': 'Zarządzanie strategią',
        'Charging Schedule': 'Harmonogram ładowania',
        'Charge Start Time': 'Czas rozpoczęcia ładowania',
        'Charge End Time': 'Czas zakończenia ładowania',
        'Discharge Start Time': 'Czas rozpoczęcia rozładowania',
        'Discharge End Time': 'Czas zakończenia rozładowania',
        'Total Rated Power': 'Całkowita moc znamionowa',
        'Total Rated Capacity': 'Całkowita pojemność znamionowa',
        // Energy Indicator
        "Today's Charge": "Dzisiejsze ładowanie",
        "Today's Discharge": "Dzisiejsze rozładowanie",
        "Today's Generation": "Dzisiejsza generacja",
        'Total Fuel Consumption': 'Całkowite zużycie paliwa',
        'Total Charge': 'Całkowite ładowanie',
        'Total Discharge': 'Całkowite rozładowanie',
        'Total Generation': 'Całkowita generacja',
        'Total Revenue': 'Całkowity przychód',
        'Total Photovoltaic Generation': 'Całkowita generacja fotowoltaiczna',
        'Total EV Charger Consumption': 'Całkowite zużycie ładowarek EV',
        'Total Load Consumption': 'Całkowite zużycie obciążenia',
        'Total Grid Buy': 'Całkowity zakup z sieci',
        'Total Grid Sell': 'Całkowita sprzedaż do sieci',
        'Total Efficiency': 'Całkowita efektywność',
        'Discharge Achievement Rate': 'Wskaźnik realizacji rozładowania',
        // Revenue Indicator
        "Today's Cost": "Dzisiejszy koszt",
        "Today's Income": "Dzisiejszy dochód",
        "Total Cost": "Łączny koszt",
        "Total Income": "Łączny dochód",
        "Today's Revenue": "Dzisiejszy zysk",

        'Revenue Ranking': 'Ranking przychodów',
        'Efficiency Ranking': 'Ranking efektywności',
        'Charge Ranking': 'Ranking ładowania',
        'Discharge Ranking': 'Ranking rozładowania',
        'Number of Microgrids': 'Liczba mikrosieci',
        'Number of Power Stations': 'Liczba elektrowni',
        'Microgrid List': 'Lista mikrosieci',
        'Select Microgrid': 'Wybierz mikrosieć',
        'Previous Page': 'Poprzednia strona',
        'Next Page': 'Następna strona',
        '7 Days': '7 dni',
        'Charge UNIT': 'Ładuj {{UNIT}}',
        'Discharge UNIT': 'Rozładuj {{UNIT}}',
        'Generation UNIT': 'Generuj {{UNIT}}',
        'Energy Indicator': 'Energia',
        'Revenue Indicator': 'Przychód',
        'Carbon Indicator': 'Węgiel',

        // Energy Storage Power Station
        'Battery Operating State': 'Stan pracy baterii',
        'Battery State': 'Stan baterii',
        'Battery Unknown': 'Nieznany',
        'Battery Stopped': 'Zatrzymany',
        'Battery Reserved': 'Zarezerwowany',
        'Battery Fault': 'Usterka',
        'Battery Warning': 'Ostrzeżenie',
        'Battery Standby': 'Czuwanie',
        'Battery Prohibit DisCharging': 'Zabronione rozładowanie',
        'Battery Prohibit Charging': 'Zabronione ładowanie',
        'Battery Normal': 'Normalny',
        'Battery Charging': 'Ładowanie',
        'Battery Discharging': 'Rozładowanie',
        'Battery Idle': 'Bezczynny',
        'Phase of Lifecycle': 'Faza cyklu życia',
        'Use Phase': 'Eksploatacja',
        'Commissioning Phase': 'Rozruch',
        'Commissioning Date': 'Data oddania do użytku',
        'Installation Phase': 'W budowie',
        'Device Status': 'Status urządzenia',
        'Basic Information': 'Informacje podstawowe',
        'Gateway': 'Brama',
        'Grid Meter': 'Licznik sieci',
        'Load Meter': 'Licznik obciążenia',
        'ESS Meter': 'Licznik magazynowania energii',
        'Total Active Power': 'Całkowita moc czynna',
        'Active Power A': 'Moc czynna fazy A',
        'Active Power B': 'Moc czynna fazy B',
        'Active Power C': 'Moc czynna fazy C',
        'Total Reactive Power': 'Całkowita moc bierna',
        'Reactive Power A': 'Moc bierna fazy A',
        'Reactive Power B': 'Moc bierna fazy B',
        'Reactive Power C': 'Moc bierna fazy C',
        'Total Apparent Power': 'Całkowita moc pozorna',
        'Apparent Power A': 'Moc pozorna fazy A',
        'Apparent Power B': 'Moc pozorna fazy B',
        'Apparent Power C': 'Moc pozorna fazy C',
        'Total Power Factor': 'Całkowity współczynnik mocy',
        'Active Energy Import': 'Energia czynna pobrana',
        'Active Energy Export': 'Energia czynna oddana',
        'Active Energy Net': 'Energia czynna netto',

        'Generator': 'Generator',

        // Photovoltaic Power Station
        'Invertor': 'Falownik',
        'Invertor Run State': 'Status pracy falownika',
        'Invertor Unknown': 'Nieznany',
        'Invertor Initializing': 'Inicjalizacja zasilania',
        'Invertor Standby': 'Czuwanie',
        'Invertor Shutdown': 'Wyłączony',
        'Invertor Fault': 'Usterka',
        'Invertor Running': 'Praca',

        //Advanced Reporting & Knowledge Base
        'Created Datetime': 'Czas utworzenia',
        'File Format': 'Format pliku',
        'File Size': 'Rozmiar pliku',
        Uploader: 'Przesyłający',
        'Upload Datetime': 'Czas przesłania',
        //Error
        "The page you're looking for is not found": 'Strona, której szukasz, nie została znaleziona',
        "Make sure the address is correct and that the page hasn't moved": 'Upewnij się, że adres jest poprawny i strona nie została przeniesiona',
        'If you think this is a mistake,': 'Jeśli uważasz, że to błąd,',
        'contact us': 'skontaktuj się z nami',
        'Take me home': 'Zabierz mnie do strony głównej',
        'Whoops, something went wrong!': 'Ups, coś poszło nie tak!',
        'Try refreshing the page, or going back and attempting the action again':
            'Spróbuj odświeżyć stronę lub cofnąć się i ponowić akcję',
        'If this problem persists,': 'Jeśli problem się utrzymuje,',
        'Captcha Error': 'Błąd kodu weryfikacyjnego',
        'Confirm Password Error': 'Hasła nie są zgodne',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            'Wygląda na to, że kliknąłeś w nieprawidłowy link resetowania hasła. Spróbuj ponownie.',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            'Wygląda na to, że kliknąłeś w nieprawidłowy link rejestracji konta. Spróbuj ponownie.',
        //Tenant Bill
        'Lease Contract Number': 'Numer umowy najmu',
        Download: 'Pobierz',
        Print: 'Drukuj',
        'Payment Notice': 'Powiadomienie o płatności',
        'Bill To': 'Do',
        'Bill Number': 'Numer rachunku',
        'Bill Date': 'Data rachunku',
        'Payment Due Date': 'Termin płatności',
        'Amount Payable': 'Kwota do zapłaty',
        'Billing Period Start': 'Początek okresu rozliczeniowego',
        'Billing Period End': 'Koniec okresu rozliczeniowego',
        Quantity: 'Ilość',
        Price: 'Cena',
        Unit: 'Jednostka',
        Amount: 'Kwota',
        Subtotal: 'Suma częściowa',
        'VAT Output Tax': 'Podatek VAT należny',
        'Total Amount Payable': 'Łączna kwota do zapłaty',
        'Please make sure to pay on or before the payment due date above': 'Upewnij się, że zapłacisz w lub przed powyższym terminem płatności',
        'Send money to the following account': 'Prześlij pieniądze na następujące konto',
        'Account Name': 'Nazwa konta',
        'Bank Name': 'Nazwa banku',
        'Bank Address': 'Adres banku',
        'RMB Account': 'Konto RMB',
        // button
        'Toggle Navigation': 'Przełącz nawigację',
        // working calendar
        'Working Days': 'Dni robocze',
        'Non Working Days': 'Dni wolne od pracy',
        'Select Row': 'Wybierz wiersz do operacji',
        // Offline Meter Input
        'Daily Value': 'Dane dzienne',
        Date: 'Data',
        'Successfully Saved': 'Zapisano pomyślnie',
        'Previous Data Is Empty': 'Poprzednie dane są puste',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Sesja administratora nie istnieje',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Sesja administratora wygasła',
        'API.ADVANCED_REPORT_NOT_FOUND': 'Zaawansowany raport nie istnieje',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': 'Złe żądanie',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Nie można ustawić licznika, który już jest podlicznikiem, jako licznika głównego',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Relacja między urządzeniem zespolonym a urządzeniem już istnieje',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Relacja między urządzeniem zespolonym a urządzeniem nie istnieje',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Relacja między urządzeniem zespolonym a licznikiem już istnieje',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relacja między urządzeniem zespolonym a licznikiem nie istnieje',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nazwa urządzenia zespolonego jest już w użyciu',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Urządzenie zespolone nie istnieje',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relacja między urządzeniem zespolonym a licznikiem offline już istnieje',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relacja między urządzeniem zespolonym a licznikiem offline nie istnieje',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Nazwa parametru powiązanego z urządzeniem zespolonym jest już w użyciu',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parametr powiązany z urządzeniem zespolonym nie istnieje lub nie pasuje',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relacja między urządzeniem zespolonym a licznikiem wirtualnym już istnieje',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relacja między urządzeniem zespolonym a licznikiem wirtualnym nie istnieje',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not  found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Nazwa kontaktu jest już w użyciu',
        'API.CONTACT_NOT_FOUND': 'Kontakt nie istnieje',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Zewnętrzny ID centrum kosztów już istnieje',
        'API.COST_CENTER_NAME_EXISTS': 'Nazwa centrum kosztów już istnieje',
        'API.COST_CENTER_NOT_FOUND': 'Centrum kosztów nie istnieje',
        'API.COST_FILE_NOT_FOUND': 'Plik kosztów nie istnieje',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Nazwa źródła danych jest już w użyciu',
        'API.DATA_SOURCE_NOT_FOUND': 'Źródło danych nie istnieje',
        'API.DATABASE_ERROR': 'Błąd bazy danych',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Data jest już w kalendarzu roboczym',
        'API.DATE_LOCAL_NOT_FOUND': 'Nie znaleziono daty lokalnej',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Nazwa obwodu rozdziału energii jest już w użyciu',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Obwód rozdziału energii nie istnieje',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Relacja między obwodem rozdziału energii a punktem już istnieje',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Relacja między obwodem rozdziału energii a punktem nie istnieje',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Nazwa systemu rozdziału energii jest już w użyciu',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'System rozdziału energii nie istnieje',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': 'Adres e-mail jest już w użyciu',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'Wiadomość e-mail nie istnieje',
        'API.EMAIL_NOT_FOUND': 'Adres e-mail nie istnieje',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Host serwera pocztowego jest już w użyciu',
        'API.EMAIL_SERVER_NOT_FOUND': 'Host serwera pocztowego nie istnieje',
        'API.EMPTY_VARIABLES_ARRAY': 'Pusta tablica zmiennych',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Nazwa kategorii energii jest już w użyciu',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'Kategoria energii nie istnieje',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Kategoria energii jest już używana w pozycjach energii',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'Kategoria energii jest już używana w liczniku',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Kategoria energii jest już używana w liczniku offline',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Kategoria energii jest już używana w taryfach',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Kategoria energii jest już używana w liczniku wirtualnym',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Łącze schematu przepływu energii jest już w użyciu',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Łącze schematu przepływu energii nie istnieje lub nie pasuje',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Nazwa schematu przepływu energii jest już w użyciu',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Węzeł schematu przepływu energii jest już w użyciu',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Węzeł schematu przepływu energii nie istnieje lub nie pasuje',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Schemat przepływu energii nie istnieje',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Pozycja energii nie należy do kategorii energii',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Pozycja energii nie należy do kategorii energii',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Pozycja energii jest już w użyciu',
        'API.ENERGY_ITEM_NOT_FOUND': 'Pozycja energii nie istnieje',
        'API.ENERGY_ITEM_USED_IN_METER': 'Pozycja energii jest już używana w liczniku',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Pozycja energii jest już używana w liczniku offline',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Pozycja energii jest już używana w liczniku wirtualnym',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'Relacja między urządzeniem a licznikiem już istnieje',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relacja między urządzeniem a licznikiem nie istnieje',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nazwa urządzenia jest już w użyciu',
        'API.EQUIPMENT_NOT_FOUND': 'Urządzenie nie istnieje',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relacja między urządzeniem a licznikiem offline już istnieje',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relacja między urządzeniem a licznikiem offline nie istnieje',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Nazwa parametru powiązanego z urządzeniem jest już w użyciu',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parametr powiązany z urządzeniem nie istnieje lub nie pasuje',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relacja między urządzeniem a licznikiem wirtualnym już istnieje',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relacja między urządzeniem a licznikiem wirtualnym nie istnieje',
        'API.ERROR': 'Błąd',
        'API.EXCEPTION': 'Wyjątek',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': 'Nie udało się przywrócić pliku kosztów',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Nie udało się przywrócić pliku wiedzy',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Nie udało się przywrócić pliku licznika offline',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Nie udało się zapisać pliku licznika offline',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'Nie udało się przesłać pliku kosztów',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Nie udało się przesłać pliku wiedzy',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Nie udało się przesłać pliku licznika offline',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Nazwa bramy jest już w użyciu',
        'API.GATEWAY_NOT_FOUND': 'Brama nie istnieje',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': 'Nieprawidłowy ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': 'Nieprawidłowy adres',
        'API.INVALID_ADDRESS_VALUE': 'Nieprawidłowa wartość adresu',
        'API.INVALID_ADVANCED_REPORT_ID': 'Nieprawidłowy ID zaawansowanego raportu',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': 'Nieprawidłowa wartość powierzchni',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'Nieprawidłowa data i czas zakończenia okresu bazowego',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'Nieprawidłowa data i czas rozpoczęcia okresu bazowego',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': 'Nieprawidłowa prędkość transmisji',
        'API.INVALID_BUILDINGS_VALUE': 'Nieprawidłowa wartość budynków',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': 'Nieprawidłowa kategoria',
        'API.INVALID_CHANNEL': 'Nieprawidłowy kanał',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'Nieprawidłowy ID urządzenia zespolonego',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Nieprawidłowa nazwa urządzenia zespolonego',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Nieprawidłowy ID parametru powiązanego z urządzeniem zespolonym',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Nieprawidłowa nazwa parametru powiązanego z urządzeniem zespolonym',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Nieprawidłowy typ parametru powiązanego z urządzeniem zespolonym',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Nieprawidłowe UUID urządzenia zespolonego',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': 'Nieprawidłowe połączenie',
        'API.INVALID_CONSTANT_VALUE': 'Nieprawidłowa wartość stałej',
        'API.INVALID_CONTACT_ID': 'Nieprawidłowy ID kontaktu',
        'API.INVALID_CONTACT_NAME': 'Nieprawidłowa nazwa kontaktu',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': 'Nieprawidłowy ID centrum kosztów',
        'API.INVALID_COST_FILE_ID': 'Nieprawidłowy ID pliku kosztów',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': 'Nieprawidłowy ID źródła danych',
        'API.INVALID_DATA_SOURCE_NAME': 'Nieprawidłowa nazwa źródła danych',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'Nieprawidłowy protokół źródła danych',
        'API.INVALID_DATE_LOCAL': 'Nieprawidłowa data lokalna',
        'API.INVALID_DENOMINATOR_METER_UUID': 'Nieprawidłowe UUID licznika referencyjnego',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': 'Nieprawidłowa nazwa wyświetlana',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Nieprawidłowy ID obwodu rozdziału energii',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Nieprawidłowa nazwa obwodu rozdziału energii',
        'API.INVALID_DISTRIBUTION_ROOM': 'Nieprawidłowa rozdzielnia',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Nieprawidłowy ID systemu rozdziału energii',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Nieprawidłowa nazwa systemu rozdziału energii',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': 'Nieprawidłowy adres e-mail',
        'API.INVALID_EMAIL_MESSAGE_ID': 'Nieprawidłowy ID wiadomości e-mail',
        'API.INVALID_EMAIL_SERVER_HOST': 'Nieprawidłowy host serwera poczty e-mail',
        'API.INVALID_EMAIL_SERVER_ID': 'Nieprawidłowy ID serwera poczty e-mail',
        'API.INVALID_END_DATE_FORMAT': 'Nieprawidłowy format daty końcowej',
        'API.INVALID_END_DATETIME': 'Nieprawidłowa data i czas zakończenia',
        'API.INVALID_ENERGY_CATEGORY_ID': 'Nieprawidłowy ID kategorii energii',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'Nieprawidłowa nazwa kategorii energii',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Nieprawidłowy ID schematu przepływu energii',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Nieprawidłowy ID łącza schematu przepływu energii',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Nieprawidłowa nazwa schematu przepływu energii',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Nieprawidłowy ID węzła schematu przepływu energii',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Nieprawidłowa nazwa węzła schematu przepływu energii',
        'API.INVALID_ENERGY_ITEM_ID': 'Nieprawidłowy ID pozycji energii',
        'API.INVALID_ENERGY_ITEM_NAME': 'Nieprawidłowa nazwa pozycji energii',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'Nieprawidłowe równanie w wyrażeniu',
        'API.INVALID_EQUIPMENT_ID': 'Nieprawidłowy ID urządzenia',
        'API.INVALID_EQUIPMENT_NAME': 'Nieprawidłowa nazwa urządzenia',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Nieprawidłowy ID parametru powiązanego z urządzeniem',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Nieprawidłowa nazwa parametru powiązanego z urządzeniem',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Nieprawidłowy typ parametru powiązanego z urządzeniem',
        'API.INVALID_EQUIPMENT_UUID': 'Nieprawidłowe UUID urządzenia',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': 'Nieprawidłowe wyrażenie',
        'API.INVALID_EXPRESSION_OBJECT': 'Nieprawidłowy obiekt wyrażenia',
        'API.INVALID_FDD_CODE': 'Nieprawidłowy kod błędu usterki',
        'API.INVALID_FLOORS_VALUE': 'Nieprawidłowa wartość pięter',
        'API.INVALID_FROM_ADDR': 'Nieprawidłowy adres nadawcy',
        'API.INVALID_GATEWAY_ID': 'Nieprawidłowy ID bramy',
        'API.INVALID_GATEWAY_NAME': 'Nieprawidłowa nazwa bramy',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Nieprawidłowa wartość limitu górnego na godzinę',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Nieprawidłowa wartość limitu dolnego na godzinę',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': 'Nieprawidłowa wartość administratora',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'Nieprawidłowa wartość wyświetlania danych kosztów',
        'API.INVALID_IS_COUNTED_VALUE': 'Nieprawidłowa wartość liczenia',
        'API.INVALID_IS_ENABLED': 'Nieprawidłowa wartość włączone',
        'API.INVALID_IS_HIDDEN': 'Nieprawidłowa wartość ukryte',
        'API.INVALID_IS_IN_LEASE_VALUE': 'Nieprawidłowa wartość w najmie',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Nieprawidłowa wartość sumowania wejść',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'Nieprawidłowa wartość główny najemca',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Nieprawidłowa wartość sumowania wyjść',
        'API.INVALID_IS_OUTPUT_VALUE': 'Nieprawidłowa wartość sumowania wyjść',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': 'Nieprawidłowa wartość zapisywania trendu',
        'API.INVALID_IS_VIRTUAL_VALUE': 'Nieprawidłowa wartość punktu wirtualnego',
        'API.INVALID_KGCE': 'Nieprawidłowy współczynnik kg ekwiwalentu węgla',
        'API.INVALID_KGCO2E': 'Nieprawidłowy współczynnik kg emisji CO2',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'Nieprawidłowy ID pliku wiedzy',
        'API.INVALID_LATITUDE_VALUE': 'Nieprawidłowa wartość szerokości geograficznej',
        'API.INVALID_LEASE_NUMBER_VALUE': 'Nieprawidłowy numer umowy najmu',
        'API.INVALID_LONGITUDE_VALUE': 'Nieprawidłowa wartość długości geograficznej',
        'API.INVALID_LOW_LIMIT_VALUE': 'Nieprawidłowa wartość limitu dolnego',
        'API.INVALID_MASTER_METER_ID': 'Nieprawidłowy ID licznika głównego',
        'API.INVALID_MENU_ID': 'Nieprawidłowy ID menu',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': 'Nieprawidłowy szablon wiadomości',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': 'Nieprawidłowy ID licznika',
        'API.INVALID_METER_NAME': 'Nieprawidłowa nazwa licznika',
        'API.INVALID_METER_UUID': 'Nieprawidłowe UUID licznika',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': 'Nieprawidłowa wartość nazwy',
        'API.INVALID_NEW_PASSWORD': 'Nieprawidłowe nowe hasło',
        'API.INVALID_NON_WORKING_DAY_ID': 'Nieprawidłowy ID dnia wolnego od pracy',
        'API.INVALID_NOTIFICATION_ID': 'Nieprawidłowy ID powiadomienia',
        'API.INVALID_NUMERATOR_METER_UUID': 'Nieprawidłowe UUID licznika licznika',
        'API.INVALID_OBJECT_TYPE': 'Nieprawidłowy typ obiektu',
        'API.INVALID_OFFLINE_METER_DATA': 'Nieprawidłowe dane licznika offline',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'Nieprawidłowy ID pliku licznika offline',
        'API.INVALID_OFFLINE_METER_ID': 'Nieprawidłowy ID licznika offline',
        'API.INVALID_OFFLINE_METER_NAME': 'Nieprawidłowa nazwa licznika offline',
        'API.INVALID_OFFLINE_METER_UUID': 'Nieprawidłowe UUID licznika offline',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'Nieprawidłowa stała przesunięcia',
        'API.INVALID_OLD_PASSWORD': 'Nieprawidłowe stare hasło',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': 'Nieprawidłowy ID przestrzeni nadrzędnej',
        'API.INVALID_PASSWORD': 'Nieprawidłowe hasło',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': 'Nieprawidłowy prąd szczytowy',
        'API.INVALID_PEAK_LOAD': 'Nieprawidłowe obciążenie szczytowe',
        'API.INVALID_PERIOD_TYPE': 'Nieprawidłowy typ okresu',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': 'Nieprawidłowy ID punktu danych',
        'API.INVALID_POINT_NAME': 'Nieprawidłowa nazwa punktu danych',
        'API.INVALID_PORT': 'Nieprawidłowy port',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': 'Nieprawidłowy priorytet',
        'API.INVALID_PRIVILEGE': 'Nieprawidłowe uprawnienie',
        'API.INVALID_PRIVILEGE_DATA': 'Nieprawidłowe dane uprawnień',
        'API.INVALID_PRIVILEGE_ID': 'Nieprawidłowy ID uprawnienia',
        'API.INVALID_PRIVILEGE_NAME': 'Nieprawidłowa nazwa uprawnienia',
        'API.INVALID_RATIO_VALUE': 'Nieprawidłowa wartość współczynnika konwersji',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': 'Nieprawidłowa odpowiedź',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Nieprawidłowa data i czas zakończenia okresu raportowania',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Nieprawidłowa data i czas rozpoczęcia okresu raportowania',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'Nieprawidłowa wartość wymagania uwierzytelnienia',
        'API.INVALID_ROOMS_VALUE': 'Nieprawidłowa wartość pomieszczeń',
        'API.INVALID_RULE_ID': 'Nieprawidłowy ID reguły',
        'API.INVALID_RULE_NAME': 'Nieprawidłowa nazwa reguły',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': 'Nieprawidłowy ID czujnika',
        'API.INVALID_SENSOR_NAME': 'Nieprawidłowa nazwa czujnika',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SERIAL_PORT': 'Nieprawidłowy port szeregowy',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Sesja nieprawidłowa, zaloguj się ponownie',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': 'Nieprawidłowy ID hali produkcyjnej',
        'API.INVALID_SHOPFLOOR_NAME': 'Nieprawidłowa nazwa hali produkcyjnej',
        'API.INVALID_SHOPFLOOR_UUID': 'Nieprawidłowe UUID hali produkcyjnej',
        'API.INVALID_SOURCE_NODE_ID': 'Nieprawidłowy ID węzła źródłowego',
        'API.INVALID_SPACE_ID': 'Nieprawidłowy ID przestrzeni',
        'API.INVALID_SPACE_NAME': 'Nieprawidłowa nazwa przestrzeni',
        'API.INVALID_SPACE_UUID': 'Nieprawidłowe UUID przestrzeni',
        'API.INVALID_START_DATE_FORMAT': 'Nieprawidłowy format daty rozpoczęcia',
        'API.INVALID_START_DATETIME': 'Nieprawidłowa data i czas rozpoczęcia',
        'API.INVALID_STATUS': 'Nieprawidłowy status',
        'API.INVALID_STORE_ID': 'Nieprawidłowy ID sklepu',
        'API.INVALID_STORE_NAME': 'Nieprawidłowa nazwa sklepu',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'Nieprawidłowy opis typu sklepu',
        'API.INVALID_STORE_TYPE_ID': 'Nieprawidłowy ID typu sklepu',
        'API.INVALID_STORE_TYPE_NAME': 'Nieprawidłowa nazwa typu sklepu',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Nieprawidłowy uproszczony kod typu sklepu',
        'API.INVALID_STORE_UUID': 'Nieprawidłowe UUID sklepu',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': 'Nieprawidłowe SVG',
        'API.INVALID_SWITCHGEAR': 'Nieprawidłowy aparat łączeniowy',
        'API.INVALID_TARGET_NODE_ID': 'Nieprawidłowy ID węzła docelowego',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'Nieprawidłowe ceny taryfy blokowej',
        'API.INVALID_TARIFF_ID': 'Nieprawidłowy ID taryfy',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Nieprawidłowe ceny taryfy czasowej',
        'API.INVALID_TARIFF_TYPE': 'Nieprawidłowy typ taryfy',
        'API.INVALID_TENANT_ID': 'Nieprawidłowy ID najemcy',
        'API.INVALID_TENANT_NAME': 'Nieprawidłowa nazwa najemcy',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Nieprawidłowy opis typu najemcy',
        'API.INVALID_TENANT_TYPE_ID': 'Nieprawidłowy ID typu najemcy',
        'API.INVALID_TENANT_TYPE_NAME': 'Nieprawidłowa nazwa typu najemcy',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Nieprawidłowy uproszczony kod typu najemcy',
        'API.INVALID_TENANT_UUID': 'Nieprawidłowe UUID najemcy',
        'API.INVALID_TEXT_MESSAGE_ID': 'Nieprawidłowy ID wiadomości SMS',
        'API.INVALID_TIMEZONE_ID': 'Nieprawidłowy ID strefy czasowej',
        'API.INVALID_TOKEN': 'Nieprawidłowy token',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': 'Nieprawidłowa jednostka miary',
        'API.INVALID_UNIT_OF_PRICE': 'Nieprawidłowa jednostka ceny',
        'API.INVALID_UNITS': 'Nieprawidłowe jednostki',
        'API.INVALID_USER_ID': 'Nieprawidłowy ID użytkownika',
        'API.INVALID_USER_NAME': 'Nieprawidłowa nazwa użytkownika',
        'API.INVALID_USER_NAME_OR_EMAIL': 'Nieprawidłowa nazwa użytkownika lub e-mail',
        'API.INVALID_USER_PHONE': 'Nieprawidłowy numer telefonu użytkownika',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'Nieprawidłowy użytkownik, zaloguj się ponownie',
        'API.INVALID_USER_UUID': 'Nieprawidłowe UUID użytkownika',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': 'Nieprawidłowy ID licznika zmiennej',
        'API.INVALID_VARIABLE_METER_TYPE': 'Nieprawidłowy typ licznika zmiennej',
        'API.INVALID_VARIABLE_NAME': 'Nieprawidłowa nazwa zmiennej',
        'API.INVALID_VERIFICATION_CODE': 'Nieprawidłowy kod weryfikacyjny',
        'API.INVALID_VIRTUAL_METER_ID': 'Nieprawidłowy ID licznika wirtualnego',
        'API.INVALID_VIRTUAL_METER_NAME': 'Nieprawidłowa nazwa licznika wirtualnego',
        'API.INVALID_VIRTUAL_METER_UUID': 'Nieprawidłowe UUID licznika wirtualnego',
        'API.INVALID_WEB_MESSAGE_ID': 'Nieprawidłowy ID wiadomości web',
        'API.INVALID_WECHAT_MESSAGE_ID': 'Nieprawidłowy ID wiadomości WeChat',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': 'Nieprawidłowy ID kalendarza roboczego',
        'API.INVALID_WORKING_CALENDAR_NAME': 'Nieprawidłowa nazwa kalendarza roboczego',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Nie można usunąć pliku wiedzy z dysku',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'Plik bazy wiedzy nie istnieje',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': 'Licznik główny nie należy do tej samej kategorii energii',
        'API.MASTER_METER_NOT_FOUND': 'Licznik główny nie istnieje',
        'API.MENU_NOT_FOUND': 'Menu nie istnieje',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'Nazwa licznika jest już w użyciu',
        'API.METER_NOT_FOUND': 'Licznik nie istnieje',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'Zmienna licznika nie istnieje',
        'API.METER_POINT_RELATION_EXISTS': 'Relacja między licznikiem a punktem danych już istnieje',
        'API.METER_POINT_RELATION_NOT_FOUND': 'Relacja między licznikiem a punktem danych nie istnieje',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Nowe hasło nie może przekraczać 100 znaków',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': 'Dzień wolny od pracy nie istnieje',
        'API.NOT_FOUND': 'Nie istnieje',
        'API.NOTIFICATION_NOT_FOUND': 'Powiadomienie nie istnieje',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'Plik licznika offline nie istnieje',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Nazwa licznika offline jest już w użyciu',
        'API.OFFLINE_METER_NOT_FOUND': 'Licznik offline nie istnieje',
        'API.INVALID_OFFLINE_METER_VALUE': 'Nieprawidłowa wartość licznika offline',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Zmienna licznika offline nie istnieje',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Stare hasło nie może przekraczać 100 znaków',
        'API.PARENT_SPACE_NOT_FOUND': 'Przestrzeń nadrzędna nie istnieje',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Hasło nie może przekraczać 100 znaków',
        'API.PASSWORDS_MATCH': 'Nowe hasło jest takie samo jak stare',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'Nazwa punktu danych jest już w użyciu',
        'API.POINT_NOT_FOUND': 'Punkt danych nie istnieje',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Nazwa uprawnienia jest już w użyciu',
        'API.PRIVILEGE_NOT_FOUND': 'Uprawnienie nie istnieje',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'Nazwa reguły jest już w użyciu',
        'API.RULE_NOT_FOUND': 'Reguła nie istnieje',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Nazwa czujnika jest już w użyciu',
        'API.SENSOR_NOT_FOUND': 'Czujnik nie istnieje',
        'API.SENSOR_POINT_RELATION_EXISTS': 'Relacja między czujnikiem a punktem danych już istnieje',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Relacja między czujnikiem a punktem danych nie istnieje',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Relacja między halą produkcyjną a urządzeniem już istnieje',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a urządzeniem nie istnieje',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Relacja między halą produkcyjną a licznikiem już istnieje',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a licznikiem nie istnieje',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Nazwa hali produkcyjnej jest już w użyciu',
        'API.SHOPFLOOR_NOT_FOUND': 'Hala produkcyjna nie istnieje',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Relacja między halą produkcyjną a licznikiem offline już istnieje',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a licznikiem offline nie istnieje',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Relacja między halą produkcyjną a punktem danych już istnieje',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a punktem danych nie istnieje',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Relacja między halą produkcyjną a czujnikiem już istnieje',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a czujnikiem nie istnieje',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Relacja między halą produkcyjną a licznikiem wirtualnym już istnieje',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a licznikiem wirtualnym nie istnieje',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Relacja między halą produkcyjną a kalendarzem roboczym już istnieje',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a kalendarzem roboczym nie istnieje',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': 'Węzeł źródłowy nie istnieje',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Relacja między przestrzenią a urządzeniem zespolonym już istnieje',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Relacja między przestrzenią a urządzeniem zespolonym nie istnieje',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Relacja między przestrzenią a urządzeniem już istnieje',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Relacja między przestrzenią a urządzeniem nie istnieje',
        'API.SPACE_METER_RELATION_EXISTS': 'Relacja między przestrzenią a licznikiem już istnieje',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'Relacja między przestrzenią a licznikiem nie istnieje',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Nazwa przestrzeni jest już w użyciu',
        'API.SPACE_NOT_FOUND': 'Przestrzeń nie istnieje',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Przestrzeń nie istnieje w uprawnieniach',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Relacja między przestrzenią a licznikiem offline już istnieje',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relacja między przestrzenią a licznikiem offline nie istnieje',
        'API.SPACE_POINT_RELATION_EXISTS': 'Relacja między przestrzenią a punktem danych już istnieje',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'Relacja między przestrzenią a punktem danych nie istnieje',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'Relacja między przestrzenią a czujnikiem już istnieje',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Relacja między przestrzenią a czujnikiem nie istnieje',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Relacja między przestrzenią a halą produkcyjną już istnieje',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Relacja między przestrzenią a halą produkcyjną nie istnieje',
        'API.SPACE_STORE_RELATION_EXISTS': 'Relacja między przestrzenią a sklepem już istnieje',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'Relacja między przestrzenią a sklepem nie istnieje',
        'API.SPACE_TENANT_RELATION_EXISTS': 'Relacja między przestrzenią a najemcą już istnieje',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Relacja między przestrzenią a najemcą nie istnieje',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Relacja między przestrzenią a licznikiem wirtualnym już istnieje',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relacja między przestrzenią a licznikiem wirtualnym nie istnieje',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Relacja między przestrzenią a kalendarzem roboczym już istnieje',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relacja między przestrzenią a kalendarzem roboczym nie istnieje',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Data i czas rozpoczęcia muszą być wcześniejsze niż zakończenia',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': 'Relacja między sklepem a licznikiem już istnieje',
        'API.STORE_METER_RELATION_NOT_FOUND': 'Relacja między sklepem a licznikiem nie istnieje',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'Nazwa sklepu jest już w użyciu',
        'API.STORE_NOT_FOUND': 'Sklep nie istnieje',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Relacja między sklepem a licznikiem offline już istnieje',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relacja między sklepem a licznikiem offline nie istnieje',
        'API.STORE_POINT_RELATION_EXISTS': 'Relacja między sklepem a punktem danych już istnieje',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'Relacja między sklepem a punktem danych nie istnieje',
        'API.STORE_SENSOR_RELATION_EXISTS': 'Relacja między sklepem a czujnikiem już istnieje',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Relacja między sklepem a czujnikiem nie istnieje',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Nazwa typu sklepu jest już w użyciu',
        'API.STORE_TYPE_NOT_FOUND': 'Typ sklepu nie istnieje',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Uproszczony kod typu sklepu jest już w użyciu',
        'API.STORE_TYPE_USED_IN_STORE': 'Typ sklepu jest już używany w sklepie',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Relacja między sklepem a licznikiem wirtualnym już istnieje',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relacja między sklepem a licznikiem wirtualnym nie istnieje',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Relacja między sklepem a kalendarzem roboczym już istnieje',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relacja między sklepem a kalendarzem roboczym nie istnieje',
        'API.TARGET_NODE_NOT_FOUND': 'Węzeł docelowy nie istnieje',
        'API.TARIFF_IN_USE': 'Taryfa jest w użyciu',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Taryfa i centrum kosztów są już powiązane',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Taryfa i centrum kosztów nie są powiązane',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Nazwa taryfy jest już w użyciu',
        'API.TARIFF_NOT_FOUND': 'Taryfa nie istnieje',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
        'API.TENANT_METER_RELATION_EXISTS': 'Relacja między najemcą a licznikiem już istnieje',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'Relacja między najemcą a licznikiem nie istnieje',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Nazwa najemcy jest już w użyciu',
        'API.TENANT_NOT_FOUND': 'Najemca nie istnieje',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Relacja między najemcą a licznikiem offline już istnieje',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relacja między najemcą a licznikiem offline nie istnieje',
        'API.TENANT_POINT_RELATION_EXISTS': 'Relacja między najemcą a punktem danych już istnieje',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'Relacja między najemcą a punktem danych nie istnieje',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'Relacja między najemcą a czujnikiem już istnieje',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Relacja między najemcą a czujnikiem nie istnieje',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Nazwa typu najemcy jest już w użyciu',
        'API.TENANT_TYPE_NOT_FOUND': 'Typ najemcy nie istnieje',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Uproszczony kod typu najemcy jest już w użyciu',
        'API.TENANT_TYPE_USED_IN_TENANT': 'Typ najemcy jest już używany u najemcy',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Relacja między najemcą a licznikiem wirtualnym już istnieje',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relacja między najemcą a licznikiem wirtualnym nie istnieje',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Relacja między najemcą a kalendarzem roboczym już istnieje',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relacja między najemcą a kalendarzem roboczym nie istnieje',
        'API.TEXT_MESSAGE_NOT_FOUND': 'Nie znaleziono wiadomości SMS',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'Okres raportowania musi być dłuższy niż 15 minut',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'Istnieje relacja z podlicznikami',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'Istnieje relacja z przestrzeniami podrzędnymi',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'Istnieje relacja z parametrami urządzeń zespolonych',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'Istnieje relacja z urządzeniami zespolonymi',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'Istnieje relacja ze źródłami danych',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'Istnieje relacja ze schematami przepływu energii',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'Istnieje relacja z bateriami kontenerów magazynowania energii',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'Istnieje relacja z sieciami elektroenergetycznymi kontenerów magazynowania energii',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'Istnieje relacja z obciążeniami kontenerów magazynowania energii',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'Istnieje relacja z systemami konwersji mocy (PCS) kontenerów magazynowania energii',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'Istnieje relacja z parametrami urządzeń',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'Istnieje relacja z urządzeniami',
        'API.THERE_IS_RELATION_WITH_METER': 'Istnieje relacja z licznikiem',
        'API.THERE_IS_RELATION_WITH_METERS': 'Istnieje relacja z wieloma licznikami',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'Istnieje relacja z licznikiem offline',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'Istnieje relacja z wieloma licznikami offline',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'Istnieje relacja z licznikami wirtualnymi',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'Istnieje relacja z czujnikami',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'Istnieje relacja z halami produkcyjnymi',
        'API.THERE_IS_RELATION_WITH_SPACES': 'Istnieje relacja z przestrzeniami',
        'API.THERE_IS_RELATION_WITH_STORES': 'Istnieje relacja ze sklepami',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'Istnieje relacja z najemcami',
        'API.THERE_IS_RELATION_WITH_USERS': 'Istnieje relacja z użytkownikami',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'Istnieje relacja z licznikiem wirtualnym',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Istnieje relacja z wirtualnymi elektrowniami',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'To źródło danych jest używane przez licznik',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Ten licznik jest używany przez licznik wirtualny',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Ten licznik offline jest używany przez licznik wirtualny',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'Przestrzeni nie można sklonować',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'Przestrzeni nie można usunąć',
        'API.TIMEZONE_NOT_FOUND': 'Strefa czasowa nie istnieje',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Nie znaleziono tokenu, zaloguj się',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'Konto użytkownika zostało zablokowane',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'Konto użytkownika wygasło',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'Nazwa użytkownika jest już w użyciu',
        'API.USER_NOT_FOUND': 'Użytkownik nie istnieje',
        'API.USER_PASSWORD_HAS_EXPIRED': 'Hasło użytkownika wygasło',
        'API.USER_PRIVILEGE_NOT_FOUND': 'Nie znaleziono uprawnień użytkownika',
        'API.USER_SESSION_NOT_FOUND': 'Nie znaleziono sesji użytkownika',
        'API.USER_SESSION_TIMEOUT': 'Sesja użytkownika wygasła',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'UUID użytkownika nie istnieje, zaloguj się',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Nazwa licznika wirtualnego jest już w użyciu',
        'API.VIRTUAL_METER_NOT_FOUND': 'Licznik wirtualny nie istnieje',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Licznik wirtualny zmiennej nie istnieje',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Punkt danych wirtualnych powinien być wartością analogową',
        'API.WEB_MESSAGE_NOT_FOUND': 'Wiadomość web nie istnieje',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'Wiadomość WeChat nie istnieje',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Nazwa kalendarza roboczego jest już w użyciu',
        'API.WORKING_CALENDAR_NOT_FOUND': 'Kalendarz roboczy nie istnieje',

        MasterMeter: 'Licznik główny',
        SubMeter: 'Podlicznik',
        'Power Quality': 'Jakość energii elektrycznej',
        'About Power Quality': 'O jakości energii elektrycznej',
        Category: 'Kategoria',
        Type: 'Typ',
        Limit: 'Limit',
        'Normal Limit': 'Limit normalny',
        'Severe Limit': 'Limit poważny',
        Compliance: 'Wskaźnik zgodności',
        'Worst Deviation': 'Najgorsze odchylenie',
        'Worst Time': 'Czas najgorszego',
        'Severe Exceed Count': 'Liczba poważnych przekroczeń',
        'Worst Unbalance': 'Maksymalna niezrównoważenie',
        Hz: 'Hz',
        voltage: 'napięcie',
        current: 'prąd',
        frequency: 'częstotliwość',
        voltage_deviation: 'odchylenie napięcia',
        current_unbalance: 'niezrównoważenie prądu',
        voltage_unbalance: 'niezrównoważenie napięcia',
        mean_deviation_pct: 'średnie odchylenie (%)',
        p95_abs_deviation_pct: 'P95 odchylenie bezwzględne (%)',
        mean_abs_deviation_hz: 'średnie odchylenie bezwzględne (Hz)',
        frequency_deviation: 'odchylenie częstotliwości',
        p95_abs_deviation_hz: 'P95 odchylenie bezwzględne (Hz)',
        mean_unbalance_pct: 'średnie niezrównoważenie (%)',
        p95_unbalance_pct: 'P95 niezrównoważenie (%)',
        count: 'liczba',
        min: 'minimum',
        max: 'maksimum',
        mean: 'średnia',
        std: 'odchylenie standardowe',
        p5: 'P5',
        p95: 'P95'
    }
};
